import { z } from 'zod';
export const SCANNED_NODE_ID_MAX_LENGTH = 100;
/**
 * Normalize a scanned node/beacon token for storage and lookup.
 * Hex-only strings are uppercased; others are trimmed as-is.
 */
export function normalizeScannedNodeId(raw) {
    const trimmed = raw.trim();
    if (!trimmed || trimmed.length > SCANNED_NODE_ID_MAX_LENGTH) {
        return null;
    }
    if (/^[0-9A-Fa-f]+$/.test(trimmed)) {
        return trimmed.toUpperCase();
    }
    return trimmed;
}
export const ScannedNodeResolveQuerySchema = z.object({
    nodeId: z.string().trim().min(1).max(SCANNED_NODE_ID_MAX_LENGTH),
});
export const ScannedNodeResolveResponseSchema = z.discriminatedUnion('status', [
    z.object({
        status: z.literal('linked'),
        nodeId: z.string(),
        containerId: z.number().int().positive(),
        containerName: z.string(),
    }),
    z.object({
        status: z.literal('unassigned'),
        nodeId: z.string(),
    }),
    z.object({
        status: z.literal('invalid'),
        nodeId: z.string(),
    }),
]);
export const ScannedNodeResolveApiResponseSchema = z.object({
    success: z.literal(true),
    data: ScannedNodeResolveResponseSchema,
});
//# sourceMappingURL=scanned-node.js.map